var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.432 14.0106C29.7949 14.3413 29.821 14.9035 29.4904 15.2664L18.7347 27.0713L11.7553 19.9794C11.411 19.6295 11.4155 19.0667 11.7654 18.7223C12.1153 18.378 12.6781 18.3825 13.0224 18.7324L18.685 24.4863L28.1763 14.069C28.5069 13.7062 29.0691 13.68 29.432 14.0106Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.2222C30.0639 38.2222 38.2222 30.0639 38.2222 20C38.2222 9.93614 30.0639 1.77778 20 1.77778C9.93614 1.77778 1.77778 9.93614 1.77778 20C1.77778 30.0639 9.93614 38.2222 20 38.2222ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.a529eff834d192f77ec04c9c77fc0fcd.svg";
export { ForwardRef as ReactComponent };